import Nullstack from 'nullstack';
export default function IconMathXMinusY({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-math-x-minus-y",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M2 9l6 6"
  }), "   ", Nullstack.element("path", {
    d: "M2 15l6 -6"
  }), "   ", Nullstack.element("path", {
    d: "M16 9l3 5.063"
  }), "   ", Nullstack.element("path", {
    d: "M22 9l-4.8 9"
  }), "   ", Nullstack.element("path", {
    d: "M10 12h4"
  }), " ");
}